import React from "react";
import TaskTree from "../TaskTree/TaskTree";
import "./WorkspaceMainTask.css";
function WorkspaceMainTask() {
  return (
    <div className="workspace-main-holder">
      <TaskTree />
    </div>
  );
}

export default WorkspaceMainTask;
